import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent {
  @Input() title: string = 'Popup';
  @Input() data: any;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  formatValue(value: any): string {
    if (typeof value === 'boolean') {
      return value ? 'Si' : 'No';
    }
    return value;
  }
}
